module.exports = __webpack_public_path__ + "0f8bbd84cff5ad1c65954bd177f26697.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/p-peel/calm.png
 ** module id = 473
 ** module chunks = 0
 **/